import { Observable, of as observableOf } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Location, User } from '../models/customer';
import { ObservableStorage } from './observable-storage';

export class MemberStorage extends ObservableStorage<User> {
	constructor() {
		super('member', localStorage);
	}

	updateCurrentLocation(currentLocation: Location): Observable<User> {
		return super.get().pipe(
			mergeMap(user => {
				user.currentLocation = currentLocation.id;
				super.set(user);
				return observableOf(user);
			})
		);
	}
	updateShippingLocations(shippingLocations: Location[]): Observable<User> {
		return super.get().pipe(
			mergeMap(user => {
				user.shippingLocations = shippingLocations;
				super.set(user);
				return observableOf(user);
			})
		);
	}
	clearUser(): Observable<User> {
		const user: User = null;
		super.set(user);
		return observableOf(user);
	}
}
